import type { FunctionComponent } from "react";

import { useTrendingTopics } from "scmp-app/components/my-news/trending-topics/hooks";

import {
  Container,
  ShowMoreButton,
  ShowMoreButtonBox,
  StyledAddedIcon,
  StyledPlusIcon,
  TopicItem,
  TopicLeft,
  TopicName,
  TopicRight,
  TopicTag,
} from "./styles";
export type Props = {
  className?: string;
};

export const TrendingTopicsList: FunctionComponent<Props> = ({ className }) => {
  const { newFollowTopicIds, onFollow, topics } = useTrendingTopics();

  return (
    <Container className={className}>
      <ShowMoreButtonBox id="trending-topics-show-more" type="checkbox" />
      {topics.slice(0, 6).map(topic => (
        <TopicItem $followed={newFollowTopicIds.includes(topic.entityId!)} key={topic.entityId}>
          <TopicLeft>
            <TopicTag>Topic</TopicTag>
            <TopicName>{topic.name}</TopicName>
          </TopicLeft>
          <TopicRight>
            {newFollowTopicIds.includes(topic.entityId!) ? (
              <StyledAddedIcon onClick={() => onFollow(topic.entityId)} />
            ) : (
              <StyledPlusIcon onClick={() => onFollow(topic.entityId)} />
            )}
          </TopicRight>
        </TopicItem>
      ))}
      <ShowMoreButton htmlFor="trending-topics-show-more">SHOW MORE</ShowMoreButton>
    </Container>
  );
};

TrendingTopicsList.displayName = "TrendingTopicsList";
